import { render, staticRenderFns } from "./RentalList.vue?vue&type=template&id=3b959bda&scoped=true&"
import script from "./RentalList.vue?vue&type=script&lang=js&"
export * from "./RentalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b959bda",
  null
  
)

export default component.exports